import { useEffect, useState } from 'react';

export const useDelayedOpen = (open: boolean, enterDelayMs: number) => {
  const [delayReady, setDelayReady] = useState(false);

  useEffect(() => {
    if (!open || enterDelayMs === 0) return;

    const enterDelayId = window.setTimeout(
      () => setDelayReady(true),
      enterDelayMs
    );

    return () => {
      window.clearTimeout(enterDelayId);
      window.queueMicrotask(() => setDelayReady(false));
    };
  }, [enterDelayMs, open]);

  return open && (enterDelayMs === 0 || delayReady);
};
